import React, { useState, useEffect } from "react"
import { Slice } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Cookies from "./Cookies"
import GlobalPopup from "./Popup/GlobalPopup"
import ScrollToTop from "./ScrollToTop"


const Layout = ({ children }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   // window.scroll({ top: 0, behavior: 'smooth', });
  // }, []);

  const handlePopupDismiss = () => {
    setIsPopupVisible(false);
    sessionStorage.setItem('popupDismissed', true);
  }

  useEffect(() => {
    const dismissed = sessionStorage.getItem('popupDismissed');
    if (!dismissed && window.location.pathname !== '/cooking-classes/') {
      setTimeout(() => {
        setIsPopupVisible(true);
      }, 8000)
    }
  }, []);

  return (
    <>
      <Slice alias="header"></Slice>
      <ScrollToTop />
      <main className="content">{children}</main>
      <Cookies />
      <GlobalPopup isVisible={isPopupVisible} onClose={() => handlePopupDismiss()} />

      <Slice alias="footer"></Slice>
    </>
  )
}

export default Layout
